import config from '@ey/voltron-config';
import React, {useEffect, useState} from 'react';
import {useStore} from 'react-redux';
import FirstLoadOverlay from './Common/FirstLoadOverlay/FirstLoadOverlay';

export default function AppStartup(Component, {initialize} = {}) {
	return function $AppStartup(props) {
		const store = useStore();
		const [initialized, setInitialized] = useState(false);

		useEffect(() => {
			initialize({store, config, props});
			setInitialized(true);
		}, []);

		return initialized ? <Component {...props} /> : <FirstLoadOverlay />;
	};
}
